import { useContext } from 'react';
import { ChevronDown } from 'lucide-react';

import t from '@guestyci/localize/t.macro/t.macro';
import {
  Combobox,
  ComboboxTrigger,
  ComboboxContent,
  ComboboxList,
  ComboboxItem,
  Row,
} from '@guestyci/arc';

import { CurrencyContext } from 'context/CurrencyContext';
import currencySymbolMap from 'constants/currencies';
import { getSymbolFromCurrency } from 'utils';
import { getWindow } from 'utils/isBrowser';
import useDio from 'hooks/useDio';
import { WebsiteSettingsContext } from 'context/WebsiteSettingsContext';

const CurrencySelect = () => {
  const { contentConfiguration: { colorTheme: { colors = {} } = {} } = {} } = useContext(WebsiteSettingsContext);
  const { setSelectedCurrency, selectedCurrency } = useContext(CurrencyContext);
  const { dioTrack } = useDio();

  const getCurrencyText = (currencyName) => (
    <span>{`${currencyName} ${getSymbolFromCurrency(currencyName, currencySymbolMap)}`}</span>
  );

  const handleCurrencyChange = (value) => {
    if (!value || value === selectedCurrency) return;
    setSelectedCurrency(value);
    dioTrack('change_currency', 'side-effect', {
      currency: selectedCurrency,
      page: getWindow()?.location.href || '',
    });
  };

  const currencyText = getCurrencyText(selectedCurrency);

  return (
    <Combobox value={selectedCurrency} onValueChange={handleCurrencyChange}>
      <ComboboxTrigger
        data-qa="currency-select"
        className="gst-border-0 gst-bg-transparent gst-h-auto gst-py-0"
        style={{ color: colors?.headerLink || 'inherit' }}
        aria-label={t('Select currency')}
      >
        <Row justify="between" align="center" gap={2}>
          {currencyText}
          <ChevronDown className="gst-w-4 gst-h-4" />
        </Row>
      </ComboboxTrigger>
      <ComboboxContent className="gst-min-w-44">
        <ComboboxList>
          {Object.keys(currencySymbolMap).map((lang) => (
            <ComboboxItem value={lang} key={lang}>
              {getCurrencyText(lang)}
            </ComboboxItem>
          ))}
        </ComboboxList>
      </ComboboxContent>
    </Combobox>
  );
};

export default CurrencySelect;
